import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import Card from 'react-bootstrap/Card';

type BillingProps = {
  facility: Facility;
};

const hasBilling = (facility: Facility) => {
  return (
    (facility.billingName || '').trim().length > 0 &&
    (facility.billingAddress1 || '').trim().length > 0 &&
    (facility.billingAddress2 || '').trim().length > 0 &&
    (facility.billingCity || '').trim().length > 0 &&
    (facility.billingState || '').trim().length > 0 &&
    (facility.billingZip || '').trim().length > 0
  );
}

const Billing: React.FC<BillingProps> = (props) => {
  const { facility } = props;

  return (
    <Card>
      <Card.Header>Billing</Card.Header>
      <Card.Body>
        {hasBilling(facility) ?
          <div>
            {facility.billingName}<br/>
            {facility.billingAddress1}<br/>
            {facility.billingAddress2}<br/>
            {facility.billingCity}, {facility.billingState} {facility.billingZip}
          </div> :
          <em>No billing information</em>
        }
      </Card.Body>
    </Card>
  );
};

export default Billing;
